import { createSelector, EntityId } from "@reduxjs/toolkit";

import { RootState } from "app/store";
import { CaseViewerState } from "./state";

import { Dossier } from "types/Dossier";
import { DossierDevice } from "types/DossierDevice";

const selectCaseViewer = (state: RootState) => state.cases.caseViewer;

const selectDossier = createSelector(
    [selectCaseViewer],
    (state: CaseViewerState) => state.dossier,
);

const selectIsLoadingDossier = createSelector(
    [selectCaseViewer],
    (state: CaseViewerState) => state.isLoadingDossier,
);

const selectErrorLoadingDossier = createSelector(
    [selectCaseViewer],
    (state: CaseViewerState) => state.errorLoadingDossier,
);

const selectSelectedDossierDevices = createSelector(
    [selectDossier],
    (dossier: Dossier | undefined) =>
        dossier?.dossierDevices.filter((x) => x.isSelected) ?? [],
);

const selectSelectedDossierDeviceById = createSelector(
    [
        selectSelectedDossierDevices,
        (state: RootState, dossierDeviceId: EntityId) => dossierDeviceId,
    ],
    (dossierDevices: DossierDevice[], dossierDeviceId: EntityId) =>
        dossierDevices.find((x) => x.id === dossierDeviceId),
);

const selectSelectedDossierDeviceStatusById = createSelector(
    [
        selectSelectedDossierDevices,
        (state: RootState, dossierDeviceId?: EntityId) => dossierDeviceId,
    ],
    (dossierDevices: DossierDevice[], dossierDeviceId?: EntityId) =>
        dossierDeviceId &&
        dossierDevices.find((x) => x.id === dossierDeviceId)?.status,
);

export const caseViewerSelectors = {
    selectCaseViewer,
    selectDossier,
    selectIsLoadingDossier,
    selectErrorLoadingDossier,
    selectSelectedDossierDevices,
    selectSelectedDossierDeviceById,
    selectSelectedDossierDeviceStatusById,
};
